import React from 'react';
import _ from "underscore";

class Utility extends React.Component {
    // str: 日付文字列(ex."yyyy-MM-dd").
    // 区切り文字 : "-".
    static isDate(str) {
        let arr = str.split('-');
        if (arr.length !== 3) {
            return false;
        }
        const date = new Date(arr[0], arr[1] - 1, arr[2]);
        return !(arr[0] !== String(date.getFullYear()) || arr[1] !== ('0' + (date.getMonth() + 1)).slice(-2) || arr[2] !== ('0' + date.getDate()).slice(-2));
    };

    static isDateOrBlank(date) {
        if (Utility.isDate(date)) {
            return true;
        } else if (date === "") {
            return true;
        }
        return false;
    };

    static isDateAEqualOrBeforeB(dateA, dateB) {
        return (new Date(dateA) <= new Date(dateB));
    };

    static getTomorrowDate() {
        let date = new Date();
        return new Date(date.setDate(date.getDate() + 1));
    }

    static formatDate(date, format) {
        format = format.replace(/yyyy/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
        return format;
    };

    static formatTime(date, format) {
        format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
        format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
        format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
        return format;
    };

    // 現在時刻のyyyy/MM/dd hh:mm:ssの文字列を取得する.
    static getNowDatetimeString() {
        let date = new Date();
        return Utility.date2DatetimeString(date);
    }

    // 指定のDateをyyyy/MM/dd hh:mm:ssの文字列に変換する.
    static date2DatetimeString(date) {
        return Utility.formatDate(date, 'yyyy/MM/dd') + ' ' + Utility.formatTime(date, 'hh:mm:ss');
    };

    // yyyyMMddの文字列をDateに変換する.
    static toDate(str) {
        let year = str.substr(0, 4);
        let month = str.substr(4, 2);
        let date = str.substr(6, 2);
        return new Date(year + '/' + month + '/' + date);
    };

    static DISPATCH_REQUESTED = {value: 0, name: "配車要求未承認"};
    static DISPATCH_APPROVED = {value: 1, name: "配車要求承認済み"};
    static DISPATCH_REJECTED = {value: 2, name: "配車要求却下済み"};
    static CANCEL_REQUESTED = {value: 11, name: "キャンセル要求未承認"};
    static CANCEL_APPROVED = {value: 12, name: "キャンセル要求承認済み"};

    static PROGRESS_STATUSES = [
        Utility.DISPATCH_REQUESTED,
        Utility.DISPATCH_APPROVED,
        Utility.DISPATCH_REJECTED,
        Utility.CANCEL_REQUESTED,
        Utility.CANCEL_APPROVED
    ];

    static DISPATCH_PROGRESS_STATUSES = [
        Utility.DISPATCH_REQUESTED,
        Utility.DISPATCH_APPROVED,
        Utility.DISPATCH_REJECTED,
    ];

    static CANCEL_PROGRESS_STATUSES = [
        Utility.CANCEL_REQUESTED,
        Utility.CANCEL_APPROVED
    ];

    static getProgressStatusNameFromValue(value) {
        let object = _.findWhere(Utility.PROGRESS_STATUSES, {value: value});
        if (object === undefined) {
            return undefined;
        }
        return object.name;
    }

    static getPompSpecNameFromId(pompSpecs, objectId) {
        if (pompSpecs.length === 0) {
            return undefined;
        }

        let object = _.findWhere(pompSpecs, {objectId: objectId});
        if (object === undefined) {
            return undefined;
        }
        return object.name;
    }

    // ユーザー種別が"協力会社"であるかを判定する.
    static isBusinessPartnerRole(role) {
        return parseInt(role, 10) === 1;
    }

    // ユーザー種別が"KEC"であるかを判定する.
    static isKecRole(role) {
        return parseInt(role, 10) === 2;
    }

    // 申請状態が"配車要求未承認"であるかを判定する.
    static isUnapprovedProgressStatus(progressStatus) {
        return parseInt(progressStatus, 10) === 0;
    }

    // 申請状態が"配車要求承認済み"であるかを判定する.
    static isApprovedProgressStatus(progressStatus) {
        return parseInt(progressStatus, 10) === 1;
    }

    // 申請状態が"キャンセル要求未承認"であるかを判定する.
    static isUnapprovedCancelProgressStatus(progressStatus) {
        return parseInt(progressStatus, 10) === 11;
    }

    // 指定したDateの月初のDateを取得する.
    static getFirstDate(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }

    // 指定したDateの月末のDateを取得する.
    static getLastDate(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }

    // 指定したDateの指定日後のDateを取得する.
    static getAfterDate = (date, afterNum) => {
        let tmpDate = new Date(date.toString());
        return new Date(tmpDate.setDate(tmpDate.getDate() + afterNum));
    };

    // 指定したDateの次の月初のDateを取得する
    static getNextMonthFirstDate = (date) => {
        let firstDate = Utility.getFirstDate(date);
        return new Date(firstDate.setMonth(firstDate.getMonth() + 1));
    };

    // 最長配車期間を超えているか判定する.
    static MAX_DELIVERY_PERIOD_DAYS = 31;

    static isOverMaxDeliveryPeriod(sinceDate, untilDate) {
        let sinceTime = new Date(sinceDate).getTime();
        let untilTime = new Date(untilDate).getTime();
        let diffTime = untilTime - sinceTime;
        let deliveryPeriodDays = this.millisecondsToDays(diffTime) + 1;
        return deliveryPeriodDays > (this.MAX_DELIVERY_PERIOD_DAYS);
    }

    // ミリ秒を日数に変換する.
    static millisecondsToDays(milliseconds) {
        return Math.floor(milliseconds / 1000 / 60 / 60 / 24);
    }

    // nullもしくはundefinedであるか判定する.
    static isNullOrUndefined(object) {
        return _.isNull(object) || _.isUndefined(object);
    }

    // 英数字文字列を半角小文字英数字に変換する.
    static replaceAlphanumericToHalfWidthLowerAlphanumeric(rowString) {
        if (_.isNull(rowString)) {
            return rowString;
        }

        return rowString.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
        }).toLocaleLowerCase();
    }

    // 指定のデータのディープコピーを取得する.
    static getDeepCopy(source) {
        return JSON.parse(JSON.stringify(source));
    }

    //progressStatusの値を日本語表記に変換する.
    static statusToString(progressStatus) {
        switch(progressStatus) {
            case 0:
                return "配車要求未承認";
            case 1: 
                return "配車要求承認済み";
            case 2:
                return "配車要求却下済み";
            case 11:
                return "キャンセル要求未承認";
            case 12:
                return "キャンセル要求承認済み";
            default:
                return "";
        }
    }
}

export default Utility;
